import React from 'react';
import dashboardCardIconHeaderSx from './DashboardCardIconHeader.styles';
import { useTheme } from '@mui/material/styles';

export type DashboardCardIconHeaderProps = {
    icon: React.ReactNode;
};

const DashboardCardIconHeader = React.memo(({ icon }: DashboardCardIconHeaderProps) => {
    const theme = useTheme();
    const sx = dashboardCardIconHeaderSx(theme);

    const clonedIcon = React.isValidElement(icon)
        ? React.cloneElement(icon as React.ReactElement<{ style?: React.CSSProperties }>, {
              style: {
                  ...((icon as React.ReactElement<{ style?: React.CSSProperties }>).props.style ?? {}),
                  ...sx.icon,
              },
          })
        : icon;

    return (
        <div>
            <span style={sx.message}>{clonedIcon}</span>
        </div>
    );
});

export default DashboardCardIconHeader;
